type Props = {
  questions: Array<{
    question: string;
    answer: string;
  }>;
};

const FAQMarkup = (props: Props) => {
  const { questions } = props;
  if (!questions || questions.length < 1) {
    return <div />;
  }

  const parseHtmlTags = (originalString: string) => {
    let stringCopy = originalString.replace(/{/g, '<');
    stringCopy = stringCopy.replace(/}/g, '>');
    return stringCopy;
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org/',
          '@type': 'FAQPage',
          mainEntity: questions.map((item) => {
            const question = parseHtmlTags(item.question);
            const answer = parseHtmlTags(item.answer);
            return {
              '@type': 'Question',
              name: question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: answer,
              },
            };
          }),
        }),
      }}
    />
  );
};

export default FAQMarkup;
